function isDefined<T>(value: T | undefined): value is T {
    return value !== undefined;
}

const $defSpacing = 8;

export function computeSpacing(
    s1: number,
    s2?: number,
    s3?: number,
    s4?: number
): string {
    const values = [s1, s2, s3, s4].filter(isDefined);

    if (values.length === 1) {
        return `${values[0] * $defSpacing}px`;
    } else if (values.length === 2) {
        return `${values[0] * $defSpacing}px ${values[1] * $defSpacing}px`;
    } else if (values.length === 3) {
        return `${values[0] * $defSpacing}px ${values[1] * $defSpacing}px ${
            values[2] * $defSpacing
        }px`;
    } else if (values.length === 4) {
        return `${values[0] * $defSpacing}px ${values[1] * $defSpacing}px ${
            values[2] * $defSpacing
        }px ${values[3] * $defSpacing}px`;
    }

    throw new Error('Invalid number of arguments provided to computeSpacing');
}
